import { put, select, take } from 'redux-saga/effects';
import ActionTypes from 'containers/Configurator/constants/selection';
import {
  makeSelectAllDrawersSelectionArray,
  makeSelectIsSameDrawersNumberInShelvesSelected,
} from 'containers/DrawersPanel/selectors';
import { selectionDrawersAction } from 'containers/DrawersPanel/actions';
import { makeSelectIsVisibleColorsPanel } from 'containers/Configurator/selectors/general';
import { ActivePanel } from '../Configurator/constants/general';

export default function* drawersPanelShelvesSelectionSaga(): any {
  while (true) {
    yield take(ActionTypes.SHELVES_SELECTION_SUCCESS);

    const isVisibleDrawerPanel = yield select(
      makeSelectIsVisibleColorsPanel(ActivePanel.drawers),
    );
    if (isVisibleDrawerPanel) {
      const sameNumberDrawersShelvesInSelection: boolean = yield select(
        makeSelectIsSameDrawersNumberInShelvesSelected(),
      );
      const drawerSelection: number[] | null = yield select(
        makeSelectAllDrawersSelectionArray(),
      );

      if (sameNumberDrawersShelvesInSelection && drawerSelection) {
        yield put(selectionDrawersAction(drawerSelection));
      } else {
        yield put(selectionDrawersAction('All'));
      }
    }
  }
}
